<template>
  <div class="condition-item time-pre">
    <button
      v-for="item in timeShortcutOptions"
      :key="item.value"
      class="time-shortcut-item"
      :class="{ active: activeTimeShortcut === item.value }"
      type="button"
      @click.stop="handleTimeShortcutClick(item.value)"
    >
      {{ item.label }}
    </button>
  </div>
  <div v-if="activeTimeShortcut === 'custom'" class="condition-item condition-item-time">
    <ai-condition :label="label">
      <template #content>
        <time-select v-model:value="selectTime" @change="handleChange"></time-select>
      </template>
    </ai-condition>
  </div>
  <div v-else class="condition-item condition-item-time-text">
    {{ statisticsTimeText }}
  </div>
</template>

<script setup>
import { computed, nextTick } from 'vue'
import TimeSelect from '@/pages/ai-board/components/components/time-select.vue'
import AiCondition from '@/components/ai-condition/index.vue'
import { getShortcutTimeRange } from '@/pages/ai-board/components/components/time-shortcut-utils'

defineOptions({
  name: 'TimeShortcutSelect'
})

defineProps({
  label: {
    type: String,
    default: '统计时间'
  }
})

const selectTime = defineModel('value', {
  type: Array,
  default: () => []
})
const activeTimeShortcut = defineModel('activeShortcut', {
  type: String,
  default: 'custom'
})

const emits = defineEmits(['change', 'calc-heights'])

const timeShortcutOptions = [
  {
    label: '今日',
    value: 'today'
  },
  {
    label: '本周',
    value: 'week'
  },
  {
    label: '本月',
    value: 'month'
  },
  {
    label: '自定义',
    value: 'custom'
  }
]

const padDate = (value) => String(value).padStart(2, '0')

const formatDate = (date) => {
  return `${date.getFullYear()}-${padDate(date.getMonth() + 1)}-${padDate(date.getDate())}`
}

const formatMonth = (date) => {
  return `${date.getFullYear()}-${padDate(date.getMonth() + 1)}`
}

const statisticsTimeText = computed(() => {
  const [startTime, endTime] = selectTime.value
  if (!startTime || !endTime) {
    return ''
  }

  const startDate = new Date(startTime)
  const endDate = new Date(endTime)
  if (activeTimeShortcut.value === 'today') {
    return `统计时间： ${formatDate(startDate)}`
  }
  if (activeTimeShortcut.value === 'week') {
    return `统计时间： ${formatDate(startDate)} ~ ${formatDate(endDate)}`
  }
  if (activeTimeShortcut.value === 'month') {
    return `统计时间： ${formatMonth(startDate)}`
  }
  return ''
})

const handleChange = () => {
  emits('change')
}

const handleTimeShortcutClick = (value) => {
  if (activeTimeShortcut.value === value) {
    return
  }

  activeTimeShortcut.value = value
  nextTick(() => {
    emits('calc-heights')
  })
  if (value === 'custom') {
    return
  }

  selectTime.value = getShortcutTimeRange(value)
  handleChange()
}
</script>

<style lang="scss" scoped>
.condition-item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 251px;
  margin-right: 16px;
  margin-bottom: 16px;
  :deep(.el-date-editor--daterange) {
    width: 240px;
  }
}
.time-pre {
  box-sizing: border-box;
  flex-direction: row;
  align-items: center;
  width: 230px;
  height: 40px;
  padding: 4px;
  background: #f7f8fa;
  border-radius: 12px;
  .time-shortcut-item {
    box-sizing: border-box;
    height: 32px;
    padding: 0 12px;
    font-family: PingFang SC;
    font-size: 14px;
    line-height: 20px;
    color: #646566;
    cursor: pointer;
    background: transparent;
    border: 0;
    border-radius: 8px;
    outline: none;
  }
  .time-shortcut-item.active {
    color: #323233;
    background: #ffffff;
    box-shadow: 0px 0px 8px 0px rgba(22, 0, 77, 0.08);
  }
}
.condition-item-time {
  width: 336px;
}
.condition-item-time-text {
  justify-content: center;
  width: max-content;
  height: 40px;
  font-family: PingFang SC;
  font-size: 14px;
  line-height: 20px;
  color: #969799;
}
</style>
